<div
  class="metadata-target"
  [class]="ignoreClicksClass"
  [class.metadata-target--focused]="inFocus()?.value"
>
  <div class="metadata-target__input">
    <input
      #searchInput
      type="text"
      autocomplete="off"
      [id]="fieldKey"
      [name]="fieldKey"
      [placeholder]="searchPlaceholder"
      [ngModel]="query()"
      [ngModelOptions]="{standalone: true}"
      (ngModelChange)="onQueryChange($event)"
      (click)="openOptions()"
      (focus)="fieldFocus.emit()"
      (keydown)="onKeyDown($event)"
    />

    @if (query()) {
      <button type="button" class="metadata-target__clear" (click)="clearField()">
        <mat-icon>close</mat-icon>
      </button>
    }

    <button
      type="button"
      class="metadata-target__toggle"
      [class.metadata-target__toggle--open]="showOptions()"
      (click)="toggleOptions()"
    >
      <span class="metadata-target__divider"></span>

      <mat-icon>expand_more</mat-icon>
    </button>
  </div>

  @if (showOptions()) {
    <div class="metadata-target__options" role="listbox">
      @if (loading()) {
        <div class="metadata-target__message">
          <mat-spinner color="accent" diameter="16"></mat-spinner>

          <span>{{ 'TRANS__SEARCH__LOADING_INFO' | translate }}</span>
        </div>
      } @else if (!options().length) {
        <div class="metadata-target__message metadata-target__message--empty">
          @if (query()) {
            <span>{{ 'TRANS__FIELD_SELECT_OPTIONS__NO_SEARCH_RESULT' | translate }}</span>
          } @else {
            <span>{{ 'TRANS__FIELD_SELECT_OPTIONS__NO_AVAILABLE_OPTIONS' | translate }}</span>
          }
        </div>
      } @else {
        @for (displayOption of options(); track displayOption.option.artifact_id; let index = $index) {
          <button
            #optionItem
            type="button"
            role="option"
            class="metadata-target__option"
            [class.metadata-target__option--active]="index === activeIndex()"
            [attr.aria-selected]="index === activeIndex()"
            (mouseenter)="activeIndex.set(index)"
            (click)="selectOption(displayOption)"
          >
            <span class="metadata-target__option-name" [innerHTML]="displayOption.nameHtml"></span>

            @if (displayOption.objectTypes) {
              <span class="metadata-target__option-types">{{ displayOption.objectTypes }}</span>
            }
          </button>
        }
      }
    </div>
  }
</div>
